import invoiceInstance from '../instance'

const sendInvoice = (invoiceUuid, email) => {
	return email
		? invoiceInstance.post(`/invoices/${invoiceUuid}/send`, { email })
		: invoiceInstance.post(`/invoices/${invoiceUuid}/send`)
}

export default sendInvoice
